const footerNav = [
  {
    title: '内容导航',
    links: [
      { label: '热门话题', href: '#topics' },
      { label: '焦点专题', href: '#carousel' },
      { label: '精选内容', href: '#cards' },
      { label: '热度榜单', href: '#ranking' },
      { label: '最新动态', href: '#updates' },
    ],
  },
  {
    title: '服务支持',
    links: [
      { label: '移动端下载', href: '#app' },
      { label: '投稿爆料', href: '#contact' },
      { label: '常见问题', href: '#faq' },
      { label: '关于我们', href: '#about' },
    ],
  },
  {
    title: '合作伙伴',
    links: [],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-800 text-background-50 pt-14 md:pt-20 pb-8">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-water-flash-line text-background-50"></i>
              </span>
              <span className="text-lg font-heading font-black text-background-50">
                51吃瓜在线
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              国内领先的吃瓜视频内容平台，提供海量高清吃瓜视频在线观看与在线播放服务。每日更新热门爆料视频，随时随地满足你的吃瓜追剧需求。
            </p>
            <div className="flex items-center gap-3">
              <a href="#footer" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#footer" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#footer" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-live-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerNav.map((col, i) => (
            <div key={i}>
              <h4 className="text-sm font-bold text-background-50 mb-4">{col.title}</h4>
              {col.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {col.links.map((link, j) => (
                    <li key={j}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                        className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-400">虚位以待</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2020-2026 51吃瓜在线 版权所有 | 本站内容仅供娱乐，请理性吃瓜
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#footer" className="hover:text-background-200 transition-colors">隐私政策</a>
            <a href="#footer" className="hover:text-background-200 transition-colors">用户协议</a>
            <a href="#footer" className="hover:text-background-200 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}